import { SAGA_ACTIONS } from "src/_config";
import { AutoLoginWithTokenReq, LoginReq, LoginWithOtpReq, UpdateUserProfile } from "src/_common/interfaces/ApiReqRes";
import { useApiCall } from "../common/appApiCallHook";

export function useUserApi() {
  const callApi = useApiCall();

  const login = (data: LoginReq, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  };

  const loginWithOtp = (data: LoginWithOtpReq, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGIN_WITH_OTP, data, onSuccess, onError);
  };

  const updateUserProfile = (data: UpdateUserProfile, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_PROFILE, data, onSuccess, onError);
  };

  const getMe = (onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.DETAILS, null, onSuccess, onError);
  };

  const logout = (onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGOUT, null, onSuccess, onError);
  };

  const autoLoginWithToken = (data: AutoLoginWithTokenReq, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.AUTO_LOGIN, data, onSuccess, onError);
  };

  const updateDisplayName = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_DISPLAY_NAME, data, onSuccess, onError);
  };

  const checkValidToken = (onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.CHECK_VALID_TOKEN, null, onSuccess, onError);
  };

  const saveNotification = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.SAVE_NOTIFICATION, data, onSuccess, onError);
  };

  const createUpdateUserGame = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.CREATE_UPDATE_USER_GAME, data, onSuccess, onError);
  };

  const loginWithEmail = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.LOGIN_WITH_EMAIL, data, onSuccess, onError);
  };

  const registration = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.REGISTRATION, data, onSuccess, onError);
  };

  const forgotPassword = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.FORGOT_PASSWORD, data, onSuccess, onError);
  };

  const resetPassword = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.RESET_PASSWORD, data, onSuccess, onError);
  };

  const getRegistrationFieldsData = (data: unknown, onSuccess: (message: string, resp: unknown) => void, onError: (message: string, resp: unknown) => void) => {
    callApi(SAGA_ACTIONS.USER.REGISTRATION_FIELDS, data, onSuccess, onError);
  };

  return {
    callLogin: login,
    callLoginWithOtp: loginWithOtp,
    callLoginWithEmail: loginWithEmail,
    callForgotPassword: forgotPassword,
    callResetPassword: resetPassword,
    callRegistration: registration,
    callUpdateUserProfile: updateUserProfile,
    callLogout: logout,
    callGetMe: getMe,
    callAutoLoginWithToken: autoLoginWithToken,
    callUpdateDisplayName: updateDisplayName,
    callCheckValidToken: checkValidToken,
    callSaveNotification: saveNotification,
    callCreateUpdateUserGame: createUpdateUserGame,
    callGetRegistrationFieldsData: getRegistrationFieldsData,
  };
}
